import React from "react";
import Visa from "../assets/visa.png";
import MasterCard from "../assets/masterCard.png";
import Paypal from "../assets/paypal.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HotelPayment = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="card-box p-25 mb-2">
        <h4>{t("Your payment")}</h4>
        <p className="m-0 p-0 mt-2">{t("Simple, safe, and secure.")}</p>

        <div className="payment-box-card pt-4">
          <h4>{t("How do you want to pay?")}</h4>
          <ul className="list-unstyled p-0 m-0 d-flex align-items-center gap-2 mt-2">
            <li>
              <Link to="#" className="btn-img">
                <img src={Visa} alt="visa" />
              </Link>
            </li>
            <li>
              <Link to="#" className="btn-img">
                <img src={MasterCard} alt="mastercard" />
              </Link>
            </li>
            <li>
              <Link to="#" className="btn-img">
                <img src={Paypal} alt="paypal" />
              </Link>
            </li>
          </ul>

          <div className="row form-box-payment pt-3">
            <div className="col-md-12">
              <div className="mb-3">
                <label>{t("Card name")}</label>
                <input type="text" className="form-control" />
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label>{t("Card Number")}</label>
                <input type="text" className="form-control" />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label>{t("Expiration date")}</label>
                <input type="text" className="form-control" placeholder={t("MM/YY")} />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label>{t("Card Number")}</label>
                <input type="text" className="form-control" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-text mb-4">
        <p>{t('By clicking "pay now" you agree with the terms and conditions and privacy policies of Booking.com, Gotogate International AB, IndiGo, and with the fare rules.')}</p>
      </div>

      <div className="card-box p-25 mb-4">
         <div className="d-flex gap-2 mb-3">
            <div className="check-box-sec">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
            </div>
            <p>{t("I agree to receiving marketing emails from Booking.com, including promotions, personalized recommendations, rewards, travel experiences, and updates about Booking.com’s products and services.")} <span className="d-block"> {t("By signing up, you allow us to tailor offers and content to your interests by monitoring how you use Booking.com through tracking technologies. Unsubscribe anytime through your account settings or the link in any marketing email. Read our")} <Link to="#" className="text-link">{t("privacy policy")}</Link>.</span>
            <span className="d-block"> {t("Your booking is directly with FabHotel Awadhvue and by completing this booking you agree to the booking conditions, general terms, and privacy policy.")}</span></p>
        </div>
        <ul className="btn-box-bootm-stup p-0 m-0 list-unstyled d-flex align-items-center justify-content-end flex-md-nowrap flex-wrap gap-2">
          <li>
            <Link to="#" className="btn btn-border">
              {t("Check your booking")}
            </Link>
          </li>
          <li>
            <Link to="#" className="btn btn-primary">
              {t("Check your booking")}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HotelPayment;
